module.exports = __webpack_public_path__ + "img/mobile-banner3-tw.e8919325.jpg";